import { useQuery } from 'react-query';
import { getSuperAdminDiseaseList } from '../api/getSuperAdminDiseaseList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch disease master-data list (ICD-10) for super-admin screens.
 *
 * @param {Object} params - { search, page, limit, sort }
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 */
export const useSuperAdminDiseaseList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.superAdminDiseases(params),
    ({ signal }) => getSuperAdminDiseaseList(params, signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useSuperAdminDiseaseList;
